import { render, staticRenderFns } from "./headerVideo.vue?vue&type=template&id=e98d3b42&scoped=true&"
import script from "./headerVideo.vue?vue&type=script&lang=ts&"
export * from "./headerVideo.vue?vue&type=script&lang=ts&"
import style0 from "./headerVideo.vue?vue&type=style&index=0&id=e98d3b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98d3b42",
  null
  
)

export default component.exports